import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "form__header" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title-3" }, "Visualisation d'une fiche")
], -1)
const _hoisted_3 = { class: "form-content" }
const _hoisted_4 = {
  key: 0,
  class: "form-fields"
}
const _hoisted_5 = { class: "static-text" }
const _hoisted_6 = { class: "form-footer" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Modifier")

import { request } from "@/domains/api/api";
import { useUser } from "@/domains/auth/user";
import { sheetColumns } from "@/domains/statistics/config";
import { computed } from "@vue/reactivity";
import { ref } from "vue";
import { ROLE_ADMIN } from "../../users/users";
import { Sheet } from "../sheets";

type DetailedSheets = {
    [K in keyof Sheet]: null | number | string | string[];
};


export default /*#__PURE__*/_defineComponent({
  props: {
    id: null
  },
  async setup(__props: any) {

let __temp: any, __restore: any

const props = __props as { id: number }



const sheet = ref<DetailedSheets>();
if (props.id > 0) {
    sheet.value = (
  ([__temp,__restore] = _withAsyncContext(() => request<DetailedSheets>(
        "sheets/" + props.id + "?view=hydrated",
        "get"
    ).then((rs) => {
        return rs ? rs : undefined;
    }))),
  __temp = await __temp,
  __restore(),
  __temp
);
}

const user = useUser().user;
const canEdit = computed(() => {
    return (
        props.id > 0 &&
        (user.value?.roles.includes(ROLE_ADMIN) ||
            sheet.value?.user_id === user.value?.id)
    );
});

function getEntries(sheet: DetailedSheets) {
    return Object.entries(sheet).reduce<[string, string][]>((acc, entry) => {
        if (
            !entry[0].endsWith("_id") &&
            !["id", "ref", "paid_trip"].includes(entry[0])
        ) {
            const val = entry[1];
            let parsedVal: string;
            if (Array.isArray(val)) parsedVal = val.join(", ");
            else if (val === null) parsedVal = "-";
            else parsedVal = "" + val;
            let col = entry[0];
            if (sheet[col + "_id"] !== undefined) col = col + "_id";

            if (col === "date") {
                const date = new Date(parsedVal);
                parsedVal = `${date.getDate()}/${
                    date.getMonth() + 1
                }/${date.getFullYear()}`;
            } else if (col === "bracelet_num" && parsedVal === "0") {
                parsedVal = "-";
            }

            parsedVal = mappings[col] ? mappings[col][parsedVal] : parsedVal;
            parsedVal += val !== null && units[col] ? " " + units[col] : "";

            acc.push([
                sheetColumns[col as keyof Sheet]?.trad ||
                    backupTrads[col] ||
                    col,
                parsedVal,
            ]);
        }
        return acc;
    }, []);
}

const backupTrads: Record<string, string> = {
    bracelet_num: "Numéro de bracelet",
    description: "Description",
    gcp: "GPS",
    pursuit_duration: "Durée de poursuite",
    failures: "Causes d'échec",
    injuries: "Blessures",
    paid_trip_observer: "Témoin",
    paid_trip_observer_phone: "Téléphone du témoin",
    paid_trip_city: "Commune du début de l'acte",
    paid_trip_observer_padress: "Commune du début de l'acte",
    paid_trip_vehicle_power: "Puissance fiscale du véhicule",
    paid_trip_postal_code: "Code postal du début de l'acte",
};

const units: Record<string, string> = {
    weight: "kg",
    duration: "heure:min",
    pursuit_duration: "heure:min",
    pursuit_length: "m",
    path_age: "h",
    leash_length: "m",
    vehicule_km: "km",
    shot_distance: "m",
};

const mappings: Record<string, Record<string, string>> = {
    gender: { U: "Indéterminé", M: "Mâle", F: "Femelle" },
    age: {
        U: "Indéterminé",
        "1INF": "Inférieur à 1 an",
        "1SUP": "Supérieur à 1 an",
    },
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (sheet.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getEntries(sheet.value), ([key, value]) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "field static-field",
                key: key
              }, [
                _createElementVNode("p", _hoisted_5, _toDisplayString(key) + ": " + _toDisplayString(value), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_unref(canEdit))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            class: "btn btn-secondary",
            to: { name: 'sheets.edit', params: { id: __props.id } }
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})